// extracted by mini-css-extract-plugin
module.exports = {"root":"_25c1dc","authorDetails":"_1351a4","authorTitle":"_8f8800","avatar":"_aab0b2"};